import * as React from 'react';
import * as styles from './styles.css';
import './font/font.css';
import cn from 'clsx';
import { TTextLevel } from '../../../../types/typography';

export interface ITitleProps {
  children: React.ReactNode;
  color?: 'primary' | 'currentColor';
  level?: TTextLevel;
}

export const Title: React.FC<ITitleProps> = props => {
  const { children, color = 'primary', level = 1 } = props;

  const Tag: keyof JSX.IntrinsicElements = `h${level}`;
  const colorClassName = color === 'currentColor' ? 'current-color' : color;

  return <Tag className={cn(styles['text'], styles[colorClassName])}>{children}</Tag>;
};

Title.displayName = 'Title';
